export default {"src":"/_next/static/media/twitter.25315f20.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};